import { ToastPosition } from '@chakra-ui/toast';

export default {
    DURATION : 5000,
    DEFAULT_POSITION : 'top' as ToastPosition,
    CLOSABLE_BY_DEFAULT : true,
};